import React from 'react';

import { useServerBuildVersionQuery } from 'src/api';
import { BUILD_VERSION } from 'src/config';

export const useAppBuildVersions = (skip: boolean) => {
  const { data } = useServerBuildVersionQuery({ skip });
  const serverBuildVersion = React.useMemo(() => data?.buildVersion, [data?.buildVersion]);

  const [clientBuildVersion] = React.useState(BUILD_VERSION);

  return { serverBuildVersion, clientBuildVersion };
};
